<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-form @submit="handleSubmit" :form="form">
        <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入角色名称' }] }]" />
        </a-form-item>
        <a-form-item label="标识" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['slug', { rules: [{ required: true, message: '请输入角色唯一标识' }] }]" />
        </a-form-item>
        <a-form-item label="菜单" :labelCol="labelCol" :wrapperCol="EditorCol">
          <a-checkbox-group v-model="checkedKeys">
            <ul class="tree-list">
              <li v-for="first in MenuData" :key="first.value">
                <a-checkbox :value="first.value">{{ first.title }}</a-checkbox>
                <ul v-if="first.children">
                  <li v-for="sub in first.children" :key="sub.value">
                    <a-checkbox :value="sub.value">{{ sub.title }}</a-checkbox>
                    <template v-if="sub.children">
                      <div class="action-list">
                        <span>操作按钮</span>
                        <a-row>
                          <a-col :span="6" v-for="last in sub.children" :key="last.value">
                            <a-checkbox :value="last.value">
                              {{ last.title }}
                            </a-checkbox>
                          </a-col>
                        </a-row>
                      </div>
                    </template>
                  </li>
                </ul>
              </li>
            </ul>
          </a-checkbox-group>
        </a-form-item>
        <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
          <a-button :loading="formLoading" htmlType="submit" type="primary">提交</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { GoBack } from '@/components'
import { form } from '@/mixins'
import { requestData } from '@/api/api'
import permissionData from '@/config/permission.config'

const fields = ['name', 'slug']
const apiList = {
    getInfo: '/admins/roles/'
}

export default {
    name: 'AuthorityForm',
    mixins: [form],
    components: {
        GoBack
    },
    data () {
        const MenuData = permissionData
        return {
            fields,
            apiList,
            value: [],
            MenuData,
            status: true,
            replaceFields: {
                value: 'value'
            },
            checkedKeys: []
        }
    },
    mounted () {
        const that = this
        if (that.$route.params.id) {
            that.getFormData(that.$route.params.id, function (values) {
                that.checkedKeys = values.menu
            }) // 获取编辑信息
        }
    },
    methods: {
        handleSubmit (e) {
            e.preventDefault()
            const {
                form: { validateFields }
            } = this
            validateFields((errors, values) => {
                if (!errors) {
                    this.formLoading = !this.formLoading
                    let url = '/admins/roles/create'
                    let methods = 'post'
                    if (this.$route.params.id) {
                        // 有aid编辑，没aid创建
                        url = '/admins/roles/' + this.$route.params.id
                        methods = 'put'
                    }
                    values.menu = this.checkedKeys
                    requestData(url, methods, values)
                        .then(res => {
                            this.$notification.success({
                                message: res.msg
                            })
                            setTimeout(() => {
                                window.location.reload()
                            }, 300)
                        })
                        .finally(() => {
                            this.formLoading = !this.formLoading
                        })
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
}
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}
.tree-list {
    padding-left: 0;
    margin-top: 0.5rem;
    & > li {
        display: flex;
        border-bottom: 1px solid #f3f3f3;
        padding-bottom: 1rem;
        margin-bottom: 1rem;
        label {
            width: 110px;
            margin-top: 3px;
        }
        ul {
            padding-left: 1rem;
            line-height: 2;
            flex: 1 1 100px;
            li {
                display: block;
                label {
                    margin-top: 0;
                }
                .action-list {
                    background: rgba(0, 0, 0, 0.01);
                    padding: 0.5rem;
                    margin: 0.5rem 0;
                    span {
                        display: block;
                        color: rgba(0, 0, 0, 0.3);
                        font-size: 0.75rem;
                    }
                }
            }
        }
    }
}
</style>
